import { TFunction } from 'i18next';
import { TabBarItem } from '@lib/components/TabBar/constants';

type Args = {
  t: TFunction<'translation', undefined>;
  isAccessesAvailable: boolean;
  isOperationalScopeAvailable: boolean;
};

export default function getDocumentViewPageTabs({
  t,
  isAccessesAvailable,
  isOperationalScopeAvailable,
}: Args): TabBarItem[] {
  const tabs: TabBarItem[] = [{ label: t('details'), value: 'details' }];
  if (isAccessesAvailable) {
    tabs.push({ label: t('accesses'), value: 'accesses' });
  }
  if (isOperationalScopeAvailable) {
    tabs.push({ label: t('operational-scope'), value: 'operationalScope' });
  }
  tabs.push({ label: t('history'), value: 'history' });
  return tabs;
}
